export var BaggageSize;
(function (BaggageSize) {
    BaggageSize[BaggageSize["small"] = 0] = "small";
    BaggageSize[BaggageSize["middle"] = 1] = "middle";
    BaggageSize[BaggageSize["large"] = 2] = "large";
})(BaggageSize || (BaggageSize = {}));
